import React, { useEffect, useState } from "react";
import { ImQuotesLeft, ImStarFull, ImStarHalf } from "react-icons/im";
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { api_url } from "../../Constants/web_services";
import noimage from "../../Assets/images/no-image-found.jpg";

const HomeTestimonial = () => {
  const [review, setReview] = useState([]);

  useEffect(() => {
    fetch(api_url + "/api/review")
      .then((response) => response.json())
      .then((reviews) => {
        setReview(reviews);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const renderRatingStars = (rating) => {
    rating = Math.max(0, Math.min(5, rating));

    const fullStarsCount = Math.floor(rating);
    const halfStarNeeded = rating % 1 !== 0;
    const emptyStarsCount = 5 - fullStarsCount - (halfStarNeeded ? 1 : 0);

    const fullStars = Array.from({ length: fullStarsCount }, (_, index) => (
      <ImStarFull key={`full-${index}`} size={20} className="text-warning me-1" />
    ));

    const halfStar = halfStarNeeded ? (
      [<ImStarHalf key="half" size={20} className="text-warning me-1" />]
    ) : [];

    const emptyStars = Array.from({ length: emptyStarsCount }, (_, index) => (
      <ImStarFull key={`empty-${index}`} size={20} className="text-022279 me-1" />
    ));

    return [...fullStars, ...halfStar, ...emptyStars];
  };

  return (
    <>
      <div className="aon-testmonials-area sf-curve-pos">
        <div className="container">
          <div className="section-head">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <span className="sf-sub-title">Testimonial</span>
                <h2 className="sf-title">What People Say About Us</h2>
              </div>
              <div className="col-lg-6 col-md-12 text-italic">
                <p>
                  "We are passionate about delivering the highest level of
                  service to our customers. Our commitment extends to sharing
                  our extensive user experiences, ensuring that we provide you
                  with the best solutions. With a wealth of knowledge in our
                  field, we are dedicated to making your experience with us
                  exceptional. Your satisfaction is our priority, and we strive
                  to offer top-quality services. Choose us for a service that
                  combines expertise and dedication."
                </p>
              </div>
            </div>
          </div>
          <div className="section-content">
            <div className="slider-vertical-wrap">
              <Swiper
                className="pb-5"
                modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                autoplay={{ delay: 5000 }}
                breakpoints={{
                  320: {
                    spaceBetween: 5,
                    slidesPerView: 1,
                  },
                  576: {
                    spaceBetween: 5,
                    slidesPerView: 1,
                  },
                  768: {
                    spaceBetween: 5,
                    slidesPerView: 1,
                  },
                  1024: {
                    spaceBetween: 10,
                    slidesPerView: 1,
                  },
                  1280: {
                    spaceBetween: 5,
                    slidesPerView: 1,
                  },
                }}
                pagination={{ clickable: true }}
              >
                {review?.data?.length > 0
                  ? review?.data?.map((userReviews, index) => (
                    <SwiperSlide key={index}>
                      <div className="slick-testimonials-thumbnails w-30 m-auto">
                        <div className="slick-item">
                          <div className="sf-testimonial-user">
                            <div className="sf-testimonial-media">
                              <img
                                src={`${userReviews?.user?.image ? api_url + "/" + userReviews?.user?.image : noimage}`}
                                alt=""
                              />
                            </div>
                            <div className="sf-testimonial-user-detail">
                              <div className="sf-testi-user-name text-capitalize">
                                {userReviews?.user === null ? "No Name" : userReviews?.user?.username}
                              </div>
                              <div className="sf-testi-user-position">
                                Users Experience
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="slick-testimonials-carousel">
                        <div className="slick-item">
                          <div className="sf-testimonial-info text-center">
                            <div className="sf-testimonial-title">
                              {userReviews?.review}
                            </div>
                            <div className="sf-ow-pro-rating">
                              {renderRatingStars(userReviews?.rating)}
                              <br />
                              <small>
                                {userReviews?.rating ? <p className="text-danger fw-700">{userReviews?.rating}/5</p> : <></>}
                              </small>
                            </div>

                            <div className="sf-testimonial-text text-italic">
                              <h6>" {userReviews?.desc_review ? userReviews?.desc_review : <></>} "</h6>
                            </div>
                            <div className="sf-testimonial-quote">
                              <ImQuotesLeft size={30} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                  : null}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeTestimonial;
